export const MOCK_FAILED_MESSAGE = 'Không khởi động được chế độ mock (REACT_APP_SMART_AUDIT_MOCK=true). Xem console.';

interface StartAppOptions {
  /** Starts the Smart Audit mock; `null` when the mock is off. */
  startMock: (() => Promise<unknown>) | null;
  renderApp: () => void;
  renderFailure: () => void;
}

/**
 * Boots the app (`src/index.tsx`). With the mock off it just renders. With the mock on it renders only once the mock
 * has started: if starting fails for any reason, the app is not rendered at all (it would call the real auth and Smart
 * Audit servers, e.g. a login with a mock password), and a static message is shown instead.
 */
export const startApp = async ({ startMock, renderApp, renderFailure }: StartAppOptions): Promise<void> => {
  if (startMock) {
    try {
      await startMock();
    } catch (error) {
      console.error('Smart Audit mock failed to start', error);
      renderFailure();
      return;
    }
  }
  renderApp();
};

/** Replaces the content of `root` with the plain mock failure message (no React, nothing that can call a server). */
export const renderMockFailure = (root: HTMLElement | null): void => {
  if (!root) return;
  const message = document.createElement('p');
  message.setAttribute('role', 'alert');
  message.style.cssText = 'margin: 24px; font: 16px/1.5 sans-serif;';
  message.textContent = MOCK_FAILED_MESSAGE;
  root.replaceChildren(message);
};
